export default function getFarmerFullName(farmer) {
  return `${farmer?.firstName} ${farmer?.lastName}`;
}
